// ** Components
import CardsGrid from '@/components/common/CardsGrid';

// ** Types
import type React from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

export type EhrenamtCardsGridProps = {
	children: React.ReactNode;
	sx?: SxProps<Theme>;
	showAvailabilityCount?: boolean;
	availabilityLabelSuffix?: string;
	emptyStateTitle?: string;
	emptyStateMessage?: string;
};

const EhrenamtCardsGrid = ({
	children,
	sx,
	showAvailabilityCount = true,
	availabilityLabelSuffix = 'Downloads verfügbar',
	emptyStateTitle = 'Keine Downloads gefunden.',
	emptyStateMessage = 'Bitte passen Sie Ihre Suche oder Filter an.'
}: EhrenamtCardsGridProps) => {
	return (
		<CardsGrid
			animateOnView={false}
			showAvailabilityCount={showAvailabilityCount}
			availabilityLabelSuffix={availabilityLabelSuffix}
			emptyStateTitle={emptyStateTitle}
			emptyStateMessage={emptyStateMessage}
			sx={[
				{
					gridTemplateColumns: {
						xs: '1fr',
						md: 'repeat(2, minmax(0, 1fr))'
					},
					columnGap: 4,
					rowGap: 6,
					'& > div': {
						width: '100%',
						minWidth: 0,
						justifySelf: 'stretch'
					}
				},
				...(Array.isArray(sx) ? sx : sx ? [sx] : [])
			]}
		>
			{children}
		</CardsGrid>
	);
};

export default EhrenamtCardsGrid;
